import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { BlockModalDragModule } from 'app/shared/directives/block-modal-drag/block-modal-drag.module';
import { DeferRenderingModule } from 'app/shared/directives/defer-rendering/defer-rendering.module';
import { ButtonModule } from '../../../button/button.module';
import { LoadingPanelModule } from '../../../loading-panel/loading-panel.module';
import { ModalModule } from '../../../modal/modal.module';
import { PaginationModule } from '../../../pagination/pagination.module';
import { ScrollViewModule } from '../../../scroll-view/scroll-view.module';
import { TooltipModule } from '../../../tooltip/tooltip.module';
import { MapRegisterModule } from './components/map-register/map-register.module';
import { MapsManagementComponent } from './maps-management.component';

@NgModule({
  imports: [
    CommonModule,
    MatTableModule,
    PaginationModule,
    ButtonModule,
    TooltipModule,
    ScrollViewModule,
    LoadingPanelModule,
    MapRegisterModule,
    ModalModule,
    DeferRenderingModule,
    BlockModalDragModule,
  ],
  declarations: [MapsManagementComponent],
  exports: [MapsManagementComponent],
})
export class MapsManagementModule {}
